export default "__VITE_ASSET__BWbTqsMi__"